export const privacyData = {
  zh: {
    title: '个人信息收集声明',
    intro: `本《个人信息收集声明》适用于2026 家庭友好企业评选（Family Friendly Employers 2026）（以下简称“本计划”），并说明创生基金（Genovation Foundation Limited）（以下简称“创生基金”）在本计划期间如何收集、使用及处理参与者的个人信息。

如参与者对其个人信息的使用或本《个人信息收集声明》有任何要求、疑问或关注事项，可以查阅并参考创生基金[《隐私政策》](/privacy-policy)，或通过 [ffe-contact@genovationfoundation.org](mailto:ffe-contact@genovationfoundation.org) 与我们联系。`,
    sections: [
      {
        heading: '我们收集的信息及处理目的',
        content: `为评估参与企业在家庭友好相关措施方面的实践情况，创生基金将向参与者收集以下类别的信息（以下简称“信息”）：

- 参与企业的企业名称、联系人姓名、联系人岗位、联系人手机号码、联系人电子邮箱、邮箱验证码、企业营业执照/工牌证明（具体以页面展示的信息内容为准）。

请注意，如您代表他人提供其个人信息，您有责任确保相关人士已知悉您向创生基金提供其个人信息，并已同意您基于上述目的向创生基金披露其个人信息。

收集相关信息后，创生基金将根据参与者提供的联系方式向其发送问卷，以了解参评企业在家庭友好举措建设方面的具体情况，并由创生基金的专家评审团对相关信息进行分析和评估。`,
      },
      {
        heading: '信息共享',
        content: `为确保评估的充分性和有效性，创生基金也会向以下合作机构（以下简称“合作机构”）共享参评企业的调研材料，并由相关合作机构协助进行分析和评估：

- LinkedIn（领英）中国（[renzhang@linkedin.com](mailto:renzhang@linkedin.com)）
- 雇主品牌研究所（[info@ebiglobal.cn](mailto:info@ebiglobal.cn)）
- 杰出雇主调研机构（[china@top-employers.com](mailto:china@top-employers.com)）

接收相关信息的合作机构均须根据相关协议承担保密义务及信息保护责任。`,
      },
      {
        heading: '信息的保存及删除',
        content: `创生基金仅会在实现上述目的所需的期限内，以及为履行适用法律规定的义务所需的期限内保存相关信息。

上述期限届满后，创生基金将根据适用的信息保护法律，以安全的方式删除相关信息或对其进行匿名化处理。`,
      },
      {
        heading: '个人信息相关权利',
        content: `根据适用的信息保护法律，本计划参与者就其个人信息享有以下权利，包括：

- 查阅其个人信息的权利；
- 更正其个人信息的权利；
- 删除其个人信息的权利；
- 反对处理其个人信息的权利；
- 限制处理其个人信息的权利；以及
- 撤回其就处理其个人信息所作同意的权利。

如参与者反对或撤回其就处理个人信息所作的同意，或要求限制处理或删除其个人信息，则将无法继续参与本计划。

参与者亦有权就其个人信息的处理，向相关监管机构提出投诉。`,
      },
      {
        heading: '个人信息的境外处理和传输',
        content: `**由于创生基金为一家设立于中国香港的企业机构，因此参与者的个人信息将被收集并存储于中国香港，以用于本计划之目的。此外，如前所述，创生基金会将相关信息传输至中国境内的合作机构。**

创生基金已采取适当措施，确保接收相关信息的合作机构均受保密义务约束，并通过适当的合同保障措施，提供与参与者所在地相同水平的信息保护，以确保相关信息将按照本《个人信息收集声明》受到保护，包括符合适用信息保护法律所要求的任何标准合同条款。`,
      },
    ],
  },

  zh_TW: {
    title: '個人資料收集聲明',
    intro: `本《個人資料收集聲明》適用於**2026 家庭友善企業評選（Family Friendly Employers 2026）**（下稱「**本計劃**」），並說明**創生基金（Genovation Foundation Limited）**（下稱「**創生基金**」）於本計劃期間將如何收集及使用參與者的個人資料。

如參與者對其個人資料的使用或本《個人資料收集聲明》有任何要求、疑問或關注事項，可以查阅并参考创生基金[《隐私政策》](/privacy-policy)，或是透過 [ffe-contact@genovationfoundation.org](mailto:ffe-contact@genovationfoundation.org) 與我們聯絡。`,
    sections: [
      {
        heading: '我們收集的資料及處理目的',
        content: `為評估參與企業在家庭友善相關措施方面的實踐情況，創生基金將向參與者收集以下類別的資料（「**資料**」）：

- 參與企業的企业名称、联系人姓名、联系人岗位、联系人手机、联系人邮箱、邮箱验证码、企业的营业执照/工牌证明（具体以页面展示的资料内容为准）。

請注意，如您代表他人提供其個人資料，您有責任確保有關人士已知悉您向創生基金提供其個人資料，並已同意您就上述目的向創生基金披露其個人資料。

收集资料后，创生基金会基于联系方式向参与者发送问卷，以了解参评企业在家庭友好举措建设方面的具体情况，并由创生基金的专家评审团对相关资料进行分析、评估。`,
      },
      {
        heading: '資料的共享',
        content: `为保障评估的充分性，創生基金也會向以下合作机构（“合作机构”）共享参评企业的调研材料，并由该合作机构协助进行分析、评估。

- LinkedIn（领英）中国（[renzhang@linkedin.com](mailto:renzhang@linkedin.com)）
- 雇主品牌研究所（[info@ebiglobal.cn](mailto:info@ebiglobal.cn)）
- 杰出雇主调研机构（[china@top-employers.com](mailto:china@top-employers.com)）

接收有關資料的合作机构均須根據合約承擔保密及保障有關資料的責任。`,
      },
      {
        heading: '資料的保存及刪除',
        content: `創生基金僅會於達成上述目的所需期間，以及為履行適用法律義務所需期間保存有關資料。

其後，創生基金將根據適用的資料保障法律，以安全方式刪除有關資料或將其作匿名化處理。`,
      },
      {
        heading: '有關資料的權利',
        content: `根據適用的資料保障法律，本計劃參與者就其個人資料享有以下權利，包括：

- 查閱其個人資料的權利；
- 更正其個人資料的權利；
- 刪除其個人資料的權利；
- 反對處理其個人資料的權利；
- 限制處理其個人資料的權利；以及
- 撤回其就處理其個人資料所作同意的權利。

如參與者反對或撤回其就處理個人資料所作的同意，或要求限制處理或刪除其個人資料，則將無法繼續參與本計劃。

參與者亦有權就其個人資料的處理，向相關監管機構提出投訴。`,
      },
      {
        heading: '個人資料的境外处理和传输',
        content: `由于创生基金为一家设立在中国香港的企业机构，因此参与者的个人资料会收集并留存在中国香港，以用于本计划之目的。此外，如前所述，创生基金会将有关资料传输至中国境内的合作机构。

創生基金已採取適當措施，確保接收有關資料的合作机构均受保密義務約束，並透過適當的合約保障措施，提供與參與者所在地相同水平的資料保障，以確保有關資料將按照本《個人資料收集聲明》受到保護，包括符合適用資料保障法律所要求的任何標準合約條款。`,
      },
    ],
  },

  en: {
    title: 'PRIVACY NOTICE',
    intro: `This Privacy Notice applies to this [Family Friendly Employer List Program] ("**Program**") and sets out how [Genovation Foundation Limited] ("Genovation Foundation") will collect and use the personal data of participants for the duration of this Program.

If a participant has any requests, questions, or concerns about the use of personal data or this Privacy Notice, please contact us via [ffe-contact@genovationfoundation.org](mailto:ffe-contact@genovationfoundation.org).`,
    sections: [
      {
        heading: 'DATA WE COLLECT AND PURPOSES OF PROCESSING',
        content: `For the purpose of [evaluating family-friendly related practices of participating companies] Genovation Foundation will collect the following types of personal data (the "**Data**") from participants:

- [Contact information, such as name, phone number, email, and etc., of representatives from participating companies]

We would like to remind you that it is your responsibility to ensure that the person or people whose personal data you have provided are aware that you've done so, and have agreed to your sharing of their personal data with Genovation Foundation for the above purposes, where you provide personal data on behalf of someone else.`,
      },
      {
        heading: 'SHARING OF DATA',
        content: `Genovation Foundation will only share the Data with [external judging panel] who will be responsible for [evaluating family-friendly related practices of participating companies]. Genovation Foundation may also share the Data internally with affiliated companies, as necessary for the purposes of this Program. All recipients of the Data are subject to contractual obligations to protect the Data provided to them.`,
      },
      {
        heading: 'STORAGE AND DELETION OF DATA',
        content: `Genovation Foundation will only store the data for as long as necessary to fulfill the purposes above and as required to comply with our legal obligations. Afterward, Genovation Foundation will securely delete or anonymize the Data in accordance with applicable data protection laws.`,
      },
      {
        heading: 'RIGHTS CONCERNING DATA',
        content: `According to applicable data protection laws, participants in the Program have the rights concerning their Data, including the right to access, rectify or erase their Data, as well as the right to object to, restrict or withdraw consent for the processing of their Data. If a participant objects to or withdraws consent for the processing of his Data, or otherwise requests restriction or deletion, then the participant will no longer be able to participate in this Program. Participants also have the right to lodge a complaint about the processing of their Data with the supervisory authorities.`,
      },
      {
        heading: 'INTERNATIONAL TRANSFERS OF DATA',
        content: `Genovation Foundation may transfer the Data to countries outside of the country or region where Genovation Foundation collects such Data. Genovation Foundation has taken appropriate steps to ensure that the recipients of the Data are bound to duties of confidentiality and appropriate contractual safeguards to provide the same level of data protection as in a participant's home country and ensure the Data will remain protected in accordance with this Privacy Notice – including any standard contractual clauses required by applicable data laws.`,
      },
    ],
  },
};
